import BaseComponent from '../../../js/base-component';
import { Loader } from "@googlemaps/js-api-loader";

class StoreAddress extends BaseComponent {
    constructor(options) {
        super(options);

        const apiKey = "AIzaSyBQ_aCybg5OOLgDeSGbDDptzH2hQ_vTfgA"; // serger live -- AIzaSyDLMPo5PSk4wq8Z67lS7m72fmdnRJ6CCxA

        this.mapContainer = document.querySelector('.u-store-address .u-address__map');
        this.openingHours = document.querySelector('.u-store-address select.u-address__opening-hours') || '';

        //if(this.openingHours) {
            // this.presetOpeningHours();
        //}

        window.addEventListener('CookiebotOnAccept', (e) => {
            if (Cookiebot.consent.preferences) {
                this.consent = Cookiebot.consent.preferences;

                // load Maps, apikey & version
                this.loader = new Loader({
                    apiKey: apiKey,
                    version: "weekly",
                });

                if ( this.mapContainer && this.consent ) {
                    this.loadMap();
                }
            }
        }, false);
    }

    loadMap() {
        const lat = Number(this.mapContainer.dataset.latitude);
        const lng = Number(this.mapContainer.dataset.longitude);

        this.mapContainer.classList.remove('not-loaded');

        this.loader.load().then(() => {
            let map = new google.maps.Map(this.mapContainer, {
                center: { lat: lat, lng: lng },
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
                zoom: 14,
            });

            new google.maps.Marker({
                position: { lat: lat, lng: lng },
                map
            });
        });
    }

    /**
     * preset the date dropdown with day of week
     */
    presetOpeningHours() {
        const date = new Date();
        let dayOfWeek = date.getDay();

        this.openingHours.value = dayOfWeek;
    }
}

export default {
    name: 'StoreAddress',
    definition: StoreAddress
};
